const MOStringUtils = require("./utils/MOStringUtils");
const jsrsasign_1 = require("jsrsasign");
export default class JWTVerifier{

    constructor(jwt,secret) {
        this.jwt = jwt;
        this.signedJwt = "";
        this.alg = "";
        this.secret = secret;
    }
    prepare() {
        if (MOStringUtils.default.isEmpty(this.secret)) {
            throw new Error("Secret Key to verify JWT is empty");
        }
        this.alg = this.jwt.getAlg();
        return this;
    }
    verify() {
        let jwt = this.jwt.getEncodedJwt() + '.' + this.jwt.getSign();
        return this.verifyTimes() && jsrsasign_1.KJUR.jws.JWS.verify(jwt, this.secret, [this.alg]);
    }
    verifyTimes() {
        let currentTime = new Date();
        if (currentTime.getTime() < this.jwt.getNbf().getTime()) {
            return false;
        }
        if (currentTime.getTime() > this.jwt.getExpiry().getTime()) {
            return false;
        }
        return true;
    }
    getSignedJwt() {
        return this.signedJwt;
    }
}
//# sourceMappingURL=JWTVerifier.js.map